const earnings = {
    en: {
        "earnings.title": "Earnings & Payroll",
        "earnings.report": "Earnings report",
        "earnings.from": "From",
        "earnings.to": "To",
        "earnings.apply": "Apply",
        "earnings.clear": "Clear",
        "earnings.income": "Income",
        "earnings.payroll": "Payroll",
        "earnings.net": "Net",
        "earnings.transactions": "Transactions",
        "earnings.byType": "Income by type",
        "earnings.byMonth": "Income by month",
        "earnings.type": "Type",
        "earnings.month": "Month",
        "earnings.amount": "Amount",
        "earnings.count": "Count",
        "earnings.noData": "No data for this period",

        "payroll.title": "Payroll",
        "payroll.record": "Record salary",
        "payroll.employee": "Employee",
        "payroll.period": "Period",
        "payroll.note": "Note",
        "payroll.submit": "Save",
        "payroll.selectEmployee": "Select employee",
        "payroll.paidBy": "Paid by",
        "payroll.date": "Date",
        "payroll.actions": "Actions",
        "payroll.delete": "Delete",
        "payroll.none": "No salary payments yet",
        "payroll.filterPeriod": "Filter by period",
        "payroll.all": "All",
        "payroll.confirmDelete": "Delete this salary payment?",
    },
    ru: {
        "earnings.title": "Доходы и зарплаты",
        "earnings.report": "Отчёт о доходах",
        "earnings.from": "С",
        "earnings.to": "По",
        "earnings.apply": "Применить",
        "earnings.clear": "Сбросить",
        "earnings.income": "Доход",
        "earnings.payroll": "Зарплаты",
        "earnings.net": "Чистая прибыль",
        "earnings.transactions": "Транзакции",
        "earnings.byType": "Доход по типу",
        "earnings.byMonth": "Доход по месяцам",
        "earnings.type": "Тип",
        "earnings.month": "Месяц",
        "earnings.amount": "Сумма",
        "earnings.count": "Кол-во",
        "earnings.noData": "Нет данных за период",

        "payroll.title": "Зарплаты",
        "payroll.record": "Записать зарплату",
        "payroll.employee": "Сотрудник",
        "payroll.period": "Период",
        "payroll.note": "Примечание",
        "payroll.submit": "Сохранить",
        "payroll.selectEmployee": "Выберите сотрудника",
        "payroll.paidBy": "Выплатил",
        "payroll.date": "Дата",
        "payroll.actions": "Действия",
        "payroll.delete": "Удалить",
        "payroll.none": "Выплат пока нет",
        "payroll.filterPeriod": "Фильтр по периоду",
        "payroll.all": "Все",
        "payroll.confirmDelete": "Удалить эту выплату?",
    },
    geo: {
        "earnings.title": "შემოსავლები და ხელფასები",
        "earnings.report": "შემოსავლების ანგარიში",
        "earnings.from": "დან",
        "earnings.to": "მდე",
        "earnings.apply": "გაფილტვრა",
        "earnings.clear": "გასუფთავება",
        "earnings.income": "შემოსავალი",
        "earnings.payroll": "ხელფასები",
        "earnings.net": "წმინდა მოგება",
        "earnings.transactions": "ტრანზაქციები",
        "earnings.byType": "შემოსავალი ტიპის მიხედვით",
        "earnings.byMonth": "შემოსავალი თვეების მიხედვით",
        "earnings.type": "ტიპი",
        "earnings.month": "თვე",
        "earnings.amount": "თანხა",
        "earnings.count": "რაოდენობა",
        "earnings.noData": "ამ პერიოდზე მონაცემები არ არის",

        "payroll.title": "ხელფასები",
        "payroll.record": "ხელფასის დაფიქსირება",
        "payroll.employee": "თანამშრომელი",
        "payroll.period": "პერიოდი",
        "payroll.note": "შენიშვნა",
        "payroll.submit": "შენახვა",
        "payroll.selectEmployee": "აირჩიეთ თანამშრომელი",
        "payroll.paidBy": "გასცა",
        "payroll.date": "თარიღი",
        "payroll.actions": "მოქმედებები",
        "payroll.delete": "წაშლა",
        "payroll.none": "ხელფასები ჯერ არ გაცემულა",
        "payroll.filterPeriod": "ფილტრი პერიოდით",
        "payroll.all": "ყველა",
        "payroll.confirmDelete": "წავშალო ეს ხელფასი?",
    },
};

export default earnings;
